import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  Box,
  FlexSection,
  FlexContainer,
  FlexDiv,
} from "@/components/Atoms/Box";
import theme from "@/foundation/Theme";
import { Typography } from "@/foundation/Typography/V2";
import TextTransition, { presets } from "react-text-transition";
import { color, space, layout, typography, flexbox } from "styled-system";
import Image from "@/components/Atoms/Image";
import Button from "@/components/Atoms/Button";

function HeroSection(props) {
  const { data = {}, handleScrollToSection = () => {}, width } = props || {};
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      3000 // every 3 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);
  return (
    <>
      <SectionWrap>
        <Container>
          <LHSSection>
            <TextWrapper>
              <Typography
                letterSpacing={"0.12em"}
                variant={"label3"}
                fontFamily={"var(--man-800)"}
                color={theme.colorsV2.shyft.purple_text}
                textTransform={"uppercase"}
                mb={"24px"}
              >
                {data?.hero?.badge}
              </Typography>
              <Title //display3 replica
                color={theme.colorsV2.primary.shade_900}
                fontSize={["36px", "40px", "44px"]}
                lineHeight={["48px", "52px", "56px"]}
                fontFamily={"var(--man-800)"}
                letterSpacing={""}
                mb={"24px"}
              >
                {data?.hero?.hero_title}{" "}
                <AnimateTransition
                  inline
                  className="animate-text"
                  springConfig={presets.gentle}
                >
                  {data?.hero?.keywords?.length > 0
                    ? data?.hero?.keywords[
                        [index % data?.hero?.keywords?.length]
                      ]
                    : ""}
                </AnimateTransition>
              </Title>
              {data?.hero?.hero_subtitle && (
                <Typography
                  variant={"label1"}
                  isExtraBold
                  color={theme.colorsV2.primary.shade_900}
                  mb={"24px"}
                >
                  {data?.hero?.hero_subtitle}
                </Typography>
              )}
              {data?.hero?.hero_cta_title && (
                <FlexDiv>
                  <ShadowBtn
                    bgColor={theme.colorsV2.shyft.purple_text}
                    fontFamily={"var(--man-700)"}
                    hoverColor={theme.colorsV2.shyft.purple_text}
                    variant={"primary1"}
                    onClick={handleScrollToSection}
                  >
                    {data?.hero?.hero_cta_title}
                  </ShadowBtn>
                </FlexDiv>
              )}
            </TextWrapper>
          </LHSSection>
          {width > 1279 && data?.hero?.hero_background && (
            <RHSSection>
              <ImageWRapper>
                <Image src={data?.hero?.hero_background} />
              </ImageWRapper>
            </RHSSection>
          )}
        </Container>
      </SectionWrap>
    </>
  );
}

export default HeroSection;

const SectionWrap = styled(FlexSection)`
  background-color: ${theme.colorsV2.shyft.cream};
  padding: 120px 0 56px;
  @media only screen and (max-width: 1279px) {
    padding: 56px 0;
  }
`;
const Container = styled(FlexContainer)`
  @media only screen and (max-width: 1279px) {
    flex-direction: column;
  }
`;
const LHSSection = styled(FlexDiv)`
  width: 100%;
  max-width: 50%;
  flex-direction: column;
  margin-right: 16px;
  justify-content: center;
  @media only screen and (max-width: 1279px) {
    max-width: 100%;
    margin-right: 0;
  }
  @media only screen and (max-width: 1279px) {
    max-width: 100%;
    margin-right: 0;
  }
`;
const RHSSection = styled(LHSSection)`
  margin-right: 0px;
  flex: 1;
  @media only screen and (max-width: 1279px) {
    display: none;
  }
`;
const TextWrapper = styled(FlexDiv)`
  flex-direction: column;
`;
const AnimateTransition = styled(TextTransition)`
  * {
    color: ${theme.colorsV2.purple.shade_600};
    font-family: inherit;
    font-size: inherit;
    white-space: nowrap;
  }
`;
const Title = styled(Box)`
  ${space}
  ${color}
  ${layout}
  ${flexbox}
    ${typography}
  .animate-text {
    font-family: inherit;
    font-size: inherit;
    @media only screen and (max-width: 850px) {
      display: block !important;
    }
    @media only screen and (max-width: 567px) {
      display: inline-block !important;
    }
    @media only screen and (max-width: 410px) {
      display: block !important;
    }
  }
`;
const ImageWRapper = styled(FlexDiv)`
  padding: 48px 20px 16px;
`;
export const ShadowBtn = styled(Button)`
  font-size: 16px;
  box-shadow: 0px 10px 20px rgba(${theme.colors.shadows.purple_3}, 0.18),
    0px 2px 6px rgba(${theme.colors.shadows.purple_3}, 0.12),
    0px 0px 1px rgba(${theme.colors.shadows.black}, 0.04);
  padding: 15px 40px;
  @media only screen and (max-width: 767px) {
    font-size: 14px;
    padding: 14.5px 40px;
  }
`;
